const refusedStiTesting = document.querySelector(
  "#participant_sti_testing_refused"
);

if (refusedStiTesting) {
  refusedStiTesting.addEventListener("change", function () {
    document
      .querySelector("#participant_sti_testing_status_attributes")
      .classList.toggle("d-none");
  });
}

//  Copyright © 2018 by Northwestern University. All Rights Reserved.
